import { SET_SIGN_OUT_IS_VISIBLE } from './constants';

const defaultState = { isVisible: false };

const signOutUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_SIGN_OUT_IS_VISIBLE:
            return { ...state, isVisible: action.isVisible };

        default:
            return state;
    }
};

export default signOutUI;



// WEBPACK FOOTER //
// ./src/containers/Inputs/SignOut/reducer.js